/**
 * ResearchPapers — presentational citations list.
 *
 * Ports the cream.html `.paper` accordion. Accepts a `papers` prop:
 *   [{ title, authors, journal, year, summary, url }]
 * Click a row to expand its summary; links open the source in a new tab.
 * Self-contained inline styles (ice-cube theme) so it carries no module CSS.
 */
import { useState } from 'react';

const ICE = '#aee3ff';
const MUTED = '#a9c4e6';

export default function ResearchPapers({ papers = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div>
      {papers.map((p, i) => {
        const isOpen = openIndex === i;
        const meta = [p.authors, p.journal, p.year].filter(Boolean).join(' · ');
        return (
          <div
            key={i}
            style={{
              background: 'rgba(255,255,255,.04)',
              border: '1px solid rgba(174,227,255,.2)',
              borderRadius: 18,
              marginBottom: 16,
              overflow: 'hidden',
            }}
          >
            <div
              onClick={() => setOpenIndex(isOpen ? null : i)}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 16,
                padding: '22px 24px',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  flex: 'none',
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  background: 'rgba(174,227,255,.14)',
                  border: '1px solid rgba(174,227,255,.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  color: ICE,
                  fontSize: 14,
                }}
              >
                {i + 1}
              </div>
              <div style={{ flex: 1 }}>
                <h4 style={{ fontSize: 16.5, fontWeight: 600, lineHeight: 1.35, margin: 0 }}>
                  {p.title}
                </h4>
                {meta && (
                  <div
                    style={{
                      color: MUTED,
                      fontSize: 12.5,
                      marginTop: 5,
                      letterSpacing: '.02em',
                    }}
                  >
                    {meta}
                  </div>
                )}
              </div>
              <div
                style={{
                  color: ICE,
                  fontSize: 18,
                  transition: 'transform .3s',
                  transform: isOpen ? 'rotate(180deg)' : 'none',
                }}
              >
                ⌄
              </div>
            </div>

            <div
              style={{
                maxHeight: isOpen ? 320 : 0,
                opacity: isOpen ? 1 : 0,
                overflow: 'hidden',
                transition: 'max-height .45s, opacity .45s',
                padding: isOpen ? '0 24px 22px 80px' : '0 24px',
              }}
            >
              {p.summary && (
                <p style={{ color: '#cfe2ff', fontSize: 14.5, lineHeight: 1.7, margin: 0 }}>
                  {p.summary}
                </p>
              )}
              {p.url && (
                <a
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: ICE,
                    textDecoration: 'none',
                    fontWeight: 600,
                    fontSize: 13,
                    display: 'inline-block',
                    marginTop: 12,
                    borderBottom: '1px solid rgba(174,227,255,.4)',
                  }}
                >
                  Read the paper ↗
                </a>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
